<div class="post-detail-overview">
  <div class="popup-card-hover-container" id="popupcontainer" *ngIf="isShow">

    <div #popup class="popup-card-hover" id="popup">
      <influencer-overview-post-content [influencerGroupId]="influencerGroupId"
                                        postId="{{'masonry-item-' + id}}"
                                        [item]="post"
                                        [displayMode]="'mobile'"
                                        (closePopupCardHover)="onClose()"
      >
      </influencer-overview-post-content>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/influencer-platform/influencer-details/influencer-overview-tab/influencer-overview-detail-popup/influencer-overview-detail-popup.component.html